'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = setCookie;
var SECONDS_IN_DAY = 24 * 60 * 60 * 1000;

function setCookie(cname, cvalue) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var exdays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 365;

  if (isBrowser) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * SECONDS_IN_DAY);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=' + path + ';';
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@axa-asia/hk-shared-utils/lib/cookies.js
// module id = 818
// module chunks = 0